const s = "_wrapper_1v9y7_1", t = "_heading_1v9y7_1", e = "_list_1v9y7_9", _ = {
  wrapper: s,
  heading: t,
  list: e
};
export {
  _ as default,
  t as heading,
  e as list,
  s as wrapper
};
